define( [
	"./whitespace"
], function( whitespace ) {

"use strict";

return new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rtrimCSS.js
// module id = 178
// module chunks = 0